import React from 'react';
import { Link } from 'react-router-dom';

interface BreadcrumbItem {
    label: string;
    path?: string;
    isCurrent?: boolean;
}

interface PageHeaderProps {
    breadcrumbs: BreadcrumbItem[];
    title: string;
    description?: string;
    descriptionLink?: {
        text: string;
        href: string;
        onClick?: () => void;
    };
}

const PageHeader: React.FC<PageHeaderProps> = ({
    breadcrumbs,
    title,
    description,
    descriptionLink
}) => {
    return (
        <>
            {/* Breadcrumbs */}
            <div className="breadcrumbs">
                {breadcrumbs.map((item, index) => (
                    <React.Fragment key={index}>
                        {item.path ? (
                            <Link to={item.path} className="breadcrumb-link">
                                {item.label}
                            </Link>
                        ) : (
                            <span className={item.isCurrent ? "breadcrumb-current" : "breadcrumb-link"}>
                                {item.label}
                            </span>
                        )}
                        {index < breadcrumbs.length - 1 && (
                            <span className="breadcrumb-separator">&gt;</span>
                        )}
                    </React.Fragment>
                ))}
            </div>

            {/* Header */}
            <div className="page-header">
                <h1 className="page-title">{title}</h1>
                {description && (
                    <p className="page-description">
                        {description}
                        {descriptionLink && (
                            <>
                                {' '}
                                <a 
                                    href={descriptionLink.href} 
                                    className="description-link"
                                    onClick={descriptionLink.onClick}
                                >
                                    {descriptionLink.text}
                                </a>
                                .
                            </>
                        )}
                    </p>
                )}
            </div>
        </>
    );
};

export default PageHeader;
